import { sva } from 'styled-system/css'

const layoutRecipe = sva({
  className: 'layoutComponent',
  slots: ['hbox', 'vbox', 'pane'],
  base: {
    hbox: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      height: 'full',
      maxHeight: 'full',
      maxWidth: 'full',
      minWidth: 0,
      width: 'full',
      '& > .layoutComponent__pane': {
        height: 'full',
        maxWidth: 'full',
      },
    },
    vbox: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      height: 'full',
      maxHeight: 'full',
      maxWidth: 'full',
      minWidth: 0,
      width: 'full',
      '& > .layoutComponent__pane': {
        maxHeight: 'full',
        width: 'full',
      },
    },
    pane: {},
  },
})

export const layoutRecipeClassnames = layoutRecipe()
